<template>
  <div class="home">
    <div class="header">
      <div class="header-main">
        <div class="left">
          <div class="menu" v-show="showMenu">
            <a @click.stop="handleToSlide(0)" href="#">首页</a>
            <a href="https://www.baidu.com/" target="_blank">产品介绍</a>
            <a href="https://www.baidu.com/" target="_blank">服务项目</a>
            <a href="https://www.baidu.com/" target="_blank">解决方案</a>
            <a href="https://www.baidu.com/" target="_blank">关于我们</a> 
            <a @click.stop="handleToSlide(8)" href="#">联系我们</a>
          </div> 
        </div>
        <a class="right" href="https://lngsaas.cn/login" target="_blank">登录</a>
      </div>
    </div>
    <swiper
      :modules="[Virtual, Mousewheel]"
      direction="virtual"
      :mousewheel="true"
      @swiper="onSwiper"
      @slide-change="onSideChange"
      class="mySwiper"
    >
      <!--       :controller="{ swiperRef }" -->
      <!-- <template v-slot:container-start>
        <div class="header">
          <div class="header-main">
            <div class="left">
              <div class="menu" v-show="showMenu">
                <a @click="handleToSlide(1)">首页</a>
                <a href="www.baidu.com" target="_blank">产品介绍</a>
                <a href="www.baidu.com" target="_blank">服务项目</a>
                <a href="www.baidu.com" target="_blank">解决方案</a>
                <a href="www.baidu.com" target="_blank">关于我们</a>
                <a href="#home-about">联系我们</a>
              </div>
            </div>
            <a class="right" href="www.baidu.com" target="_blank">登录</a>
          </div>
        </div>
      </template> -->
      <swiper-slide :virtual-index="1">
        <div class="home-main" id="home-main">
          <div class="home-main-header">
            <a @click.stop="handleToSlide(0)" href="#">首页</a>
            <a href="https://www.baidu.com/" target="_blank">产品介绍</a>
            <a href="https://www.baidu.com/" target="_blank">服务项目</a>
            <a href="https://www.baidu.com/" target="_blank">解决方案</a>
            <a href="https://www.baidu.com/" target="_blank">关于我们</a> 
            <a @click.stop="handleToSlide(8)" href="#">联系我们</a>
          </div>
          <div class="home-main-box">
            <h2>智领清洁能源</h2>
            <h3>护航绿色未来</h3>
            <p>
              汇恒深冷科技提供「LNG 加液机 + 智能管理系统」一体化解决方案<br />
              让加气站运营更高效、更安全、更智能
            </p>
            <a class="home-main-btn" href="https://www.baidu.com/" target="_blank">
              下载产品手册 >>
            </a>
          </div>
          <img class="home-main-img" src="./assets/bg43.png" /></div
      ></swiper-slide>
      <swiper-slide :virtual-index="2">
        <div class="home-page">
          <h2>一套系统 全面升级加气站运营</h2>
          <div class="home-page-main">
            <div class="home-page-main-box">
              <!-- <img src="./assets/bg44.png" /> -->
              <div class="img"></div>
              <h3>简洁</h3>
              <p>
                一机集成，告别多套系统。<br />
                加注、收款、库存、报表<br />
                全链路统一管理，新人10分钟上手。
              </p>
            </div>
            <div class="home-page-main-box">
              <h3>高效</h3>
              <p>
                语音播报、自动对账、营销工具等<br />
                赋能日常运营，流程自动跑起来，<br />
                效率提升30%+。
              </p>
              <div class="img img1"></div>
            </div>
            <div class="home-page-main-box">
              <div class="img img2"></div>
              <h3>智能</h3>
              <p>
                实时监控库存与气量盈亏，<br />
                自动生成经营看板与月度报告，<br />
                让每一方气的流向都清晰可见。
              </p>
            </div>
          </div>
        </div></swiper-slide
      >
      <swiper-slide :virtual-index="3">
        <div class="home-product">
          <h2>不止是加液机，更是智能加气站操作系统</h2>
          <div class="home-page-main">
            <div class="home-page-main-box box1">
              <!-- <img src="./assets/bg44.png" /> -->
              <h3>LNG加液机</h3>
              <p>
                单枪/双枪/机械臂<br />
                科里奥利流量计<br />
                计量器具型式批准证书<br />
                电控/整机防爆认证
              </p>
              <img class="img22" src="./assets/bg68.png" />
              <img class="img11" src="./assets/bg5.png" />
            </div>
            <div class="home-page-main-box box2">
              <h3>智能管理系统</h3>
              <p>
                一键财务报表生成<br />
                销量数据多客户端实时展示<br />
                LNG加气站 独有工作流优化<br />
                营销工具定制化开发
              </p>
              <img class="img22" src="./assets/bg6.png" />
              <img class="img11" src="./assets/bg60.png" />
            </div>
          </div></div
      ></swiper-slide>
      <swiper-slide :virtual-index="4">
        <div class="home-station">
          <div class="home-station-header">
            <span :class="kind == '1' ? 'active' : ''" @click="handleClick('1')"
              >多股东气站</span
            >
            <span :class="kind == '2' ? 'active' : ''" @click="handleClick('2')"
              >老站改造</span
            >
            <span :class="kind == '3' ? 'active' : ''" @click="handleClick('3')"
              >新站建设</span
            >
          </div>
          <div class="home-station-main">
            <div class="content">
              <div class="text" style="position: absolute;left: -50px;bottom: 160px;" v-show="kind == '1'">
                <h2>透明账目，共赢基石</h2>
                <p>痛点直击：告别月底对账迷雾，杜绝资金流向盲区。</p>
                <p>解决方案：构建“加气 - 收银 - 财务”全自动闭环体系。</p>
                <p>每一笔交易实时上链，数据不可篡改，多方股东随时可查。</p>
                <p>让信任基于真实数据，让分红清晰透明。</p>
              </div>
              <div class="text" style="position: absolute;left: -50px;bottom: 160px;" v-show="kind == '2'">
                <h2>焕新升级，效能倍增</h2>
                <p>痛点直击：突破老旧设备系统孤岛，打破功能局限瓶颈。</p>
                <p>解决方案：无缝兼容旧有加液机，植入智能收银大脑。</p>
                <p>通过多维数据报表驱动精细化运营，以数据决策替代人工经验。</p>
                <p>显著提升人效，大幅降低运营成本，让老站焕发新生机。</p>
              </div>
              <div class="text" style="position: absolute;left: -80px;bottom: 160px;" v-show="kind == '3'">
                <h2>智慧启航，赢在起点</h2>
                <p>痛点直击：规避建设弯路，拒绝系统滞后。</p>
                <p>解决方案：提供从顶层设计到落地运营的一站式智能化方案。</p>
                <p>内置会员营销、库存预警等多元运营工具，不仅建站，更助您建“生态”。</p>
                <p>以科技增强客户粘性，锁定长期收益。</p>
              </div>
              <div class="box">
                <div class="box1">
                  <img class="img1" src="./assets/bg37.png" />
                  <img class="img2" src="./assets/bg58.png" />
                  <p>数据管理</p>
                </div>
                <div class="box1" style="top: 0; left: 150px">
                  <img class="img1" src="./assets/bg36.png" />
                  <img class="img2" src="./assets/bg55.png" />
                  <p>智能化</p>
                </div>
                <div class="box1" style="top: 0; right: 178px">
                  <img class="img1" src="./assets/bg35.png" />
                  <img class="img2" src="./assets/bg53.png" />
                  <p>行业适配性</p>
                </div>
                <div class="box1" style="top: 0; right: 28px">
                  <img class="img1" src="./assets/bg34.png" />
                  <img class="img2" src="./assets/bg52.png" />
                  <p>自动化</p>
                </div>
                <div class="box1" style="top: 50%; transform: translateY(-50%)">
                  <img class="img1" src="./assets/bg33.png" />
                  <img class="img2" src="./assets/bg54.png" />
                  <p>运营管理</p>
                </div>
                <div class="box1" style="left: 90px; bottom: 0">
                  <img class="img1" src="./assets/bg44.png" />
                  <img class="img2" src="./assets/bg29.png" />
                  <p>全角色协同</p>
                </div>
                <div class="box1" style="left: 237px; bottom: 0">
                  <img class="img1" src="./assets/bg32.png" />
                  <img class="img2" src="./assets/bg57.png" />
                  <p>按需订阅</p>
                </div>
                <div class="box1" style="bottom: 0; right: 0">
                  <img class="img1" src="./assets/bg28.png" />
                  <img class="img2" src="./assets/bg74.png" />
                  <p>支付功能</p>
                </div>
                <div class="line line1"></div>
                <div class="line line2"></div>
                <div class="line line3"></div>
                <div class="line line4"></div>
                <div class="line line5"></div>
                <div class="line line6"></div>
                <div class="line line7"></div>
                <div class="line line8"></div>
                <div class="line line9"></div>
                <div class="line line10"></div>

                <img class="img27" src="./assets/bg27.png" />
              </div>
            </div>
          </div></div
      ></swiper-slide>
      <swiper-slide :virtual-index="5">
        <div class="home-machine">
          <h2>不止是加液机，更是智能加气站操作系统</h2>
          <div class="home-machine-main">
            <div class="box">
              <h3>传统收银系统</h3>
              <div class="text">
                <img src="./assets/bg13.png" />
                <p>系统按年付费</p>
              </div>
              <div class="text">
                <img src="./assets/bg26.png" />
                <p>依赖收银人员</p>
              </div>
              <div class="text">
                <img src="./assets/bg25.png" />
                <p>多数为加油站收银系统复用</p>
              </div>
              <div class="text">
                <img src="./assets/bg24.png" />
                <p>功能老旧，行业泛用性差</p>
              </div>
              <div class="text">
                <img src="./assets/bg23.png" />
                <p>资金去向明确，加液数据需要与LNG加液机核对</p>
              </div>
              <div class="text">
                <img src="./assets/bg22.png" />
                <p>不支持运营管理</p>
              </div>
            </div>
            <div class="box">
              <h3>传统LNG加液机</h3>
              <div class="text">
                <img src="./assets/bg13.png" />
                <p>不支持支付管理</p>
              </div>
              <div class="text">
                <img src="./assets/bg26.png" />
                <p>不支持自动化程度</p>
              </div>
              <div class="text">
                <img src="./assets/bg25.png" />
                <p>无特殊LNG行业适配性功能</p>
              </div>
              <div class="text">
                <img src="./assets/bg24.png" />
                <p>不支持智能化</p>
              </div>
              <div class="text">
                <img src="./assets/bg23.png" />
                <p>加液数据准确，资金去向不明确</p>
              </div>
              <div class="text">
                <img src="./assets/bg22.png" />
                <p>不支持运营管理</p>
              </div>
            </div>
            <div class="box box1">
              <h3>汇恒深冷LNG加液机</h3>
              <div class="text">
                <img src="./assets/bg16.png" />
                <p>整机集合，终身免费使用</p>
              </div>
              <div class="text">
                <img src="./assets/bg17.png" />
                <p>全自动记录订单，支付，会员积分等信息， 无需人工录入</p>
              </div>
              <div class="text">
                <img src="./assets/bg18.png" />
                <p>为LNG行业量身打造，丰富多样的实用工具</p>
              </div>
              <div class="text">
                <img src="./assets/bg19.png" />
                <p>一键财务报表，销量，库存等信息，电脑，手机实时查看</p>
              </div>
              <div class="text">
                <img src="./assets/bg20.png" />
                <p>全数据链条统一，加液数量，资金去向一目了然</p>
              </div>
              <div class="text">
                <img src="./assets/bg21.png" />
                <p>多种运营方案可选择，支持定制化开发系统</p>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide :virtual-index="6">
        <div class="home-info">
          <div class="home-info-main">
            <div class="left">
              <div class="msg">
                <img src="./assets/bg38.png" />
                <div>
                  <h3>基础系统，免费标配</h3>
                  <p>
                    购买任意型号加液机，即免费获得全套<br />
                    智能管理系统，无需额外开发费用。
                  </p>
                </div>
              </div>
              <div class="msg">
                <img src="./assets/bg39.png" />
                <div>
                  <h3>增值工具，按需订阅</h3>
                  <p>
                    红包、转盘、积分等营销功能按月开通，<br />
                    低成本试错，无强制捆绑。
                  </p>
                </div>
              </div>
              <div class="msg">
                <img src="./assets/bg40.png" />
                <div>
                  <h3>全角色协同，一屏掌控</h3>
                  <p>
                    老板看报表、财务对账目、操作员听播报，<br />
                    数据实时同步，岗位高效协作。
                  </p>
                </div>
              </div>
            </div>
            <img class="right" src="./assets/bg45.png" />
          </div></div
      ></swiper-slide>
      <swiper-slide :virtual-index="7">
        <div class="home-system">
          <div class="home-system-main">
            <h2>为智能加气站而生的系统</h2>
            <h3>
              我们从第一天起就按服务千座气站的标准构建系统——即使今天只有一家客户，代码、架构与服务承诺，始终如一。
            </h3>
            <div class="home-system-count">
              <div class="text">
                <NumberCounter
                  :target="track?.driverCount || 0"
                  :duration="track?.driverCount || 0"
                />
                <!-- <h4>{{ track?.driverCount || 0 }}</h4> -->
                <p>服务司机数量</p>
              </div>
              <div class="text">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <NumberCounter
                    :target="track?.orderCount || 0"
                    :duration="track?.orderCount || 0"
                  />
                  <span style="color: #0375F9; font-size: 2.5rem; margin-left: 4px;">万+</span>
                </div>
                <!-- <h4>{{ track?.orderCount || 0 }}</h4> -->
                <p>交易成功订单</p>
              </div>
              <div class="text">
                <NumberCounter
                  :target="track?.carTeamCount || 0"
                  :duration="track?.carTeamCount || 0"
                />
                <!-- <h4>{{ track?.carTeamCount || 0 }}</h4> -->
                <p>合作车队数量</p>
              </div>
              <div class="text">
                <!-- <h4>{{ track?.hours || 0 }}</h4> -->
                <div style="display: flex; align-items: center; justify-content: center;">
                  <NumberCounter
                    :target="track?.hours || 0"
                    :duration="track?.hours || 0"
                  />
                  <span style="color: #0375F9; font-size: 2.5rem; margin-left: 4px;">天+</span>
                </div>
                <p>系统稳定运行时长</p>
              </div>
            </div>
            <div class="home-system-bottom">
              <img class="img1" src="./assets/bg46.png" />
              <img class="img2" src="./assets/bg46.png" />
              <div class="box">
                <h5>工业级可靠性</h5>
                <div>
                  系统基于微服务架构，支持<br />
                  7×24 小时连续运行，断网<br />
                  续传、异常自恢复。
                </div>
              </div>
              <div class="box">
                <h5>开放扩展性</h5>
                <div>
                  预留 API 接口，未来可对接<br />
                  政府监管平台、第三方支付、<br />
                  ERP 财务系统。
                </div>
              </div>
              <div class="box">
                <h5>安全合规</h5>
                <div>
                  符合防爆电气标准，数据加<br />
                  密传输，权限分级管理，保<br />
                  障运营安全。
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide :virtual-index="8">
        <div class="home-used">
          <h2>丰富运营工具，按需启用</h2>
          <div class="home-used-main">
            <img class="bg" src="./assets/bg48.png" />
            <div class="tools">运营工具</div>
            <div class="box box1">
              <p>数据看板</p>
              <div class="img">
                <img class="img1" src="./assets/bg11.png" />
                <img class="img2" src="./assets/bg63.png" />
              </div>
            </div>
            <div class="box box2">
              <div class="img">
                <img class="img1" src="./assets/bg12.png" />
                <img class="img2" src="./assets/bg72.png" />
              </div>
              <p>营销红包</p>
            </div>
            <div class="box box3">
              <p>员工绩效</p>
              <div class="img">
                <img class="img1" src="./assets/bg10.png" />
                <img class="img2" src="./assets/bg64.png" />
              </div>
            </div>
            <div class="box box4">
              <div class="img">
                <img class="img1" src="./assets/bg15.png" />
                <img class="img2" src="./assets/bg65.png" />
              </div>
              <p>幸运转盘</p>
            </div>
            <div class="box box5">
              <p>超市管理</p>
              <div class="img">
                <img class="img1" src="./assets/bg30.png" />
                <img class="img2" src="./assets/bg71.png" />
              </div>
            </div>
            <div class="box box6">
              <div class="img">
                <img class="img1" src="./assets/bg14.png" />
                <img class="img2" src="./assets/bg73.png" />
              </div>
              <p>积分商城</p>
            </div>
            <div class="box box7">
              <p>库存管理</p>
              <div class="img">
                <img class="img1" src="./assets/bg70.png" />
                <img class="img2" src="./assets/bg59.png" />
              </div>
            </div>
            <div class="box box8">
              <div class="img">
                <img class="img1" src="./assets/bg31.png" />
                <img class="img2" src="./assets/bg66.png" />
              </div>
              <p>站点小程序</p>
            </div>
          </div>
        </div></swiper-slide
      >
      <swiper-slide :virtual-index="9">
        <div class="home-about" id="home-about">
          <div class="home-about-items">
            <div class="box">
              <img src="./assets/bg41.png" />
              <p>合作洽谈</p>
            </div>
            <img class="line line1" src="./assets/bg42.png" />
            <div class="box">
              <img src="./assets/bg49.png" />
              <p>企业入驻</p>
            </div>
            <img class="line line2" src="./assets/bg42.png" />
            <div class="box">
              <img src="./assets/bg50.png" />
              <p>签订协议</p>
            </div>
            <img class="line line3" src="./assets/bg42.png" />
            <div class="box">
              <img src="./assets/bg51.png" />
              <p>项目实施</p>
            </div>
          </div>
          <div class="home-about-main">
            <div class="left">
              <h2>联系我们</h2>
              <p>
                提交完成后会有专业团队尽快与您联系。<br />
                如需寻求合作、订阅前沿资讯或反馈任何意见。<br />
                欢迎填写相关信息。
              </p>
              <div class="code">
                <span>我们随时为您提供帮助</span>
                <img src="./assets/bg1.png" />
              </div>
            </div>
            <div class="right">
              <a-form
                ref="formRef"
                :model="formValue"
                layout="vertical"
                :rules="rules"
              >
                <a-row :gutter="34">
                  <a-col :span="12">
                    <a-form-item label="公司名称" name="company">
                      <a-input
                        size="large"
                        v-model:value="formValue.company"
                        placeholder="请输入您的公司名称"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item label="公司地址" name="address">
                      <a-input
                        size="large"
                        v-model:value="formValue.address"
                        placeholder="请输入您的公司地址"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item label="联系人名称" name="name">
                      <a-input
                        size="large"
                        v-model:value="formValue.name"
                        placeholder="请输入联系人名称"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item label="邮箱" name="email">
                      <a-input
                        size="large"
                        placeholder="请输入邮箱"
                        v-model:value="formValue.email"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item label="联系人电话" name="phoneNumber">
                      <a-input
                        size="large"
                        maxLength="11"
                        placeholder="请输入联系人电话"
                        v-model:value="formValue.phoneNumber"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :span="24">
                    <a-form-item label="备注" name="remark">
                      <a-textarea
                        style="resize: none"
                        :rows="2"
                        size="large"
                        :autoSize="false"
                        v-model:value="formValue.remark"
                        placeholder="请描述您具体想要合作的内容，例如合作场景、需要的产品或功能等"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
              <div class="submit">
                <div class="tip">
                  <a-checkbox v-model:checked="checked"></a-checkbox>
                  我已阅读并确认<a href="https://www.baidu.com/" target="_blank"
                    >《个人信息保护政策》</a
                  >
                </div>
                <div class="btn" @click="handleSubmit">立即提交</div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
  <!-- <div style="height: 100px" @click="handleToSlide(1)">123</div> -->
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { get, post } from "./http.js";
import { message } from "ant-design-vue";
// import { Form, FormItem, Input, Row, Col } from "ant-design-vue";
import NumberCounter from "./numberCounter.vue"; // 引入组件
import { Swiper, SwiperSlide } from "swiper/vue";
import { Virtual, Mousewheel } from "swiper/modules";
// import "swiper/swiper-bundle.css"; // 所有SWIPER样式,包括所有模块样式(如导航、选型等)模块样式(如果已导入捆绑样式则无需):
import "swiper/css/mousewheel"; // - 适用于Mousewheel模块所需的款式
// import SwiperCore, { Mousewheel } from "swiper";
// SwiperCore.use([Mousewheel]);
// const swiperOptions = ref({
//   direction: "vertical", // 垂直切换选项
//   loop: true, // 循环模式选项
//   // Swiper 配置项
//   mousewheel: {
//     sensitivity: 100, // 控制滚动的灵敏度，数值越大，滚动越敏感。
//     invert: false, // 是否反转方向，默认是 false，即向下滚动时向前切换幻灯片。
//   },
//   // 其他配置...
// });
const swiperRef = ref(null);
// const virtualIndex = ref(5);
const onSideChange = (swiper) => {
  console.log("sideChange", swiper, swiper.realIndex);
  // virtualIndex.value = swiper.activeIndex;
  showMenu.value = swiper.realIndex === 1 ? false : true;
};
const onSwiper = (swiper) => {
  swiperRef.value = swiper;
  console.log("swiper", swiper);
};
const handleToSlide = (index) => {
  console.log("handleToSlide", swiperRef.value, index);
  swiperRef.value.slideTo(index);
  // virtualIndex.value = index;
};
const kind = ref("1");
const formRef = ref();
const track = ref();
const showMenu = ref(false);
const handleClick = (e) => {
  kind.value = e;
};
const checked = ref(false);
const formValue = reactive({
  company: undefined,
  address: undefined,
  name: undefined,
  email: undefined,
  phoneNumber: undefined,
  remark: undefined,
});
const rules = {
  name: [{ required: true, message: "请输入联系人名称", trigger: "blur" }],
  phoneNumber: [
    { required: true, message: "请输入联系人电话", trigger: "blur" },
  ],
};
const handleSubmit = () => {
  if (!checked.value) {
    message.error("请阅读并确认《个人信息保护政策》");
    return;
  }
  formRef.value
    .validate()
    .then(() => {
      console.log("formValue", formValue);
      post({
        url: "api/site/contactUs",
        data: formValue,
      })
        .then((res) => {
          if (res?.code == 200) {
            formRef.value.resetFields();
            checked.value = false;
            message.success(res?.msg || "信息已提交，请耐心等待！");
          } else {
            message.error(res?.msg || "提交失败");
          }
          console.log("res", res);
        })
        .catch((error) => {
          console.log("error", error);
        });
    })
    .catch((error) => {
      console.log("error584", error);
    });
};

// const scrollTop = () => {
//   let scroll = document.documentElement.scrollTop || document.body.scrollTop;
//   // console.log(scroll, 1234213);
//   if (scroll > 150) {
//     showMenu.value = true;
//   } else {
//     showMenu.value = false;
//   }
// };
onMounted(() => {
  get({ url: "api/site/track" }).then((res) => {
    track.value = res;
  });
  // window.addEventListener("scroll", scrollTop, true);
});
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  width: 100vw;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* padding-top: 60px; */
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
a {
  text-decoration: none;
}
.home {
  width: 100vw;
  height: calc(100vh);
  position: relative;
  /* padding-top: 60px; */
}
.mySwiper {
  position: absolute;
  top: 60px;
  left: 0;
  height: 100vh;
  /* margin-top: 60px; */
}
.swiper-slide {
  width: 100vw;
  height: 100vh;
  /* margin-top: 60px; */
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #242b37;
  opacity: 1;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3),
    0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  z-index: 100;
}
.header-main {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-main .left {
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0em;
  color: #ffffff;
}
.header-main .left .menu {
}
.header-main .left a {
  margin-right: 46px;
  color: #fff;
}
.header-main .right {
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0em;
  color: #ffffff;
}
.home-main,
.home-page,
.home-product,
.home-station,
.home-machine,
.home-info,
.home-system,
.home-used,
.home-about {
  width: 100%;
  height: calc(100vh);
  position: relative;
  padding: 60px 1px 1px;
}
.home-main {
  background-image: url(./assets/bg1.png);
  background-size: cover;
  margin-top: -60px;
  padding-top: 60px;
  height: calc(100vh);
}
.home-main-header {
  display: flex;
  justify-content: space-between;
  width: 844px;
  height: 68px;
  border-radius: 34px;
  background: rgba(255, 255, 255, 0.2941);
  border: 1px solid #ffffff;
  box-shadow: 3px 3px 6px 0px rgba(114, 109, 109, 0.1529);
  margin: 80px auto;
  padding: 9px 13px;
}
.home-main-header a {
  display: block;
  width: 136px;
  height: 50px;
  border-radius: 25px;
  opacity: 1;
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 50px;
  text-align: center;
  letter-spacing: 0em;
  color: #000000;
}
.home-main-header a:hover {
  background: #ffffff;
}
.home-main-box {
  width: 1200px;
  margin: 90px auto;
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}
.home-main-box h2,
.home-main-box h3 {
  width: 576px;
  font-family: PingFangSC;
  font-size: 68px;
  font-weight: normal;
  line-height: 68px;
  letter-spacing: 0em;
  color: #161d26;
}
.home-main-box h3 {
  text-align: right;
  margin-top: 30px;
  margin-bottom: 60px;
}
.home-main-box p {
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 44px;
  letter-spacing: 0em;
  color: #414141;
  margin-bottom: 35px;
}
.home-main-box .home-main-btn {
  display: block;
  width: 236px;
  height: 54px;
  border-radius: 27px;
  opacity: 1;
  background: #161d26;
  box-shadow: 0px 1px 2px 0px #b2b2b2;
  text-align: center;
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 54px;
  letter-spacing: 0em;
  color: #ffffff;
}
.home-main-img {
  display: block;
  height: calc(100vh - 295px);
  position: absolute;
  right: 35px;
  bottom: 0;
}
.home-page {
  background: #e8faff;
}
.home-page h2,
.home-product h2,
.home-machine h2,
.home-system h2,
.home-used h2 {
  margin-top: 90px;
  font-family: PingFangSC;
  font-size: 45px;
  font-weight: normal;
  line-height: 45px;
  letter-spacing: 0em;
  color: #161d26;
  text-align: center;
}
.home-page-main {
  margin: 0 auto;
  height: calc(100vh - 196px);
  padding: 0 40px;
  /* background-color: red; */
  display: flex;
  justify-content: space-evenly;
  background: linear-gradient(180deg, rgba(214, 220, 247, 0) 0%, #d6dcf7 100%);
}
.home-page-main-box {
  width: 380px;
  height: 500px;
  margin: 80px 0;
  opacity: 1;
  /* background: #d8d8d8; */
  background: #fff;
  padding: 60px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.home-page-main-box h3 {
  font-family: PingFangSC;
  font-size: 45px;
  text-align: center;
  font-weight: normal;
  line-height: 45px;
  letter-spacing: 0em;
  color: #161d26;
}
.home-page-main-box p {
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 36px;
  text-align: center;
  letter-spacing: 0em;
  color: #414141;
}
.home-page-main-box .img {
  display: block;
  width: 100%;
  height: 120px;
  background-image: url(./assets/bg62.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.home-page-main-box:hover {
  background: linear-gradient(180deg, #2f65e9 0%, #54a0f8 100%);
  box-shadow: 1px 1px 40px 0px #4c75f4;
}
.home-page-main-box:hover h3 {
  color: #ffffff;
}
.home-page-main-box:hover p {
  color: #ffffff;
}
.home-page-main-box:hover .img {
  background-image: url(./assets/bg7.png);
}
.home-page-main-box .img1 {
  background-image: url(./assets/bg8.png);
}
.home-page-main-box:hover .img1 {
  background-image: url(./assets/bg61.png);
}

.home-page-main-box .img2 {
  background-image: url(./assets/bg9.png);
}
.home-page-main-box:hover .img2 {
  background-image: url(./assets/bg69.png);
}
.home-product .home-page-main {
  background: #fff;
}
.home-product .home-page-main .home-page-main-box {
  width: 450px;
  position: relative;
  align-items: start;
  justify-content: space-evenly;
  background: linear-gradient(180deg, #2f65e9 0%, #54a0f8 100%);
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(76, 117, 244, 0.2);
  padding-left: 50px;
}
.home-product .home-page-main .home-page-main-box h3 {
  position: absolute;
  top: 60px;
  left: 50px;
  z-index: 1;
  font-family: PingFangSC;
  font-size: 45px;
  font-weight: normal;
  line-height: 45px;
  letter-spacing: 0em;
  color: #ffffff;
}
.home-product .home-page-main .home-page-main-box p {
  position: absolute;
  top: 160px;
  left: 50px;
  z-index: 1;
  text-align: left;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #ffffff;
}
.home-product .home-page-main .home-page-main-box img {
  position: absolute;
  bottom: 0;
  right: 0;
  /* width: 370px; */
  height: 260px;
}
.home-product .home-page-main .home-page-main-box:hover {
  background: linear-gradient(180deg, #ffffff 0%, #fcfdff 65%, #e5f1fe 100%);
  box-shadow: 1px 1px 40px 0px #4c75f4;
}
.home-product .home-page-main .home-page-main-box:hover h3 {
  color: #161d26;
}
.home-product .home-page-main .home-page-main-box:hover p {
  color: #414141;
}
.home-product .home-page-main .box1 .img11 {
  display: none;
}
.home-product .home-page-main .box1 .img22 {
  display: block;
}
.home-product .home-page-main .box1:hover .img11 {
  display: block;
}
.home-product .home-page-main .box1:hover .img22 {
  display: none;
}
.home-product .home-page-main .box2 .img11 {
  display: none;
}
.home-product .home-page-main .box2 .img22 {
  display: block;
}
.home-product .home-page-main .box2:hover .img11 {
  display: block;
}
.home-product .home-page-main .box2:hover .img22 {
  display: none;
}

.home-station {
  background-color: #e8f5ff;
  /* background: linear-gradient(180deg, rgba(214, 220, 247, 0) 0%, #d6dcf7 100%); */
}
.home-station-main {
  width: 100%;
  height: calc(100vh - 181px);
  background: linear-gradient(180deg, rgba(214, 220, 247, 0) 0%, #d6dcf7 100%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-station-header {
  display: flex;
  justify-content: space-between;
  margin: 70px auto 0;
  width: 535px;
  height: 56px;
  border-radius: 29px;
  opacity: 1;
  padding: 5px;
  cursor: pointer;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.3255) 0%,
    #ffffff 56%,
    rgba(255, 255, 255, 0.3255) 99%
  );
  border: 1px solid #ffffff;
  box-shadow: 0px 1px 20px 0px rgba(76, 117, 244, 0.2);
}
.home-station-header span {
  display: block;
  width: 157px;
  height: 47px;
  line-height: 47px;
  font-family: PingFangSC;
  text-align: center;
  font-size: 24px;
  font-weight: normal;
  letter-spacing: 0em;
  border-radius: 29px;
  opacity: 1;
  border: 1px solid #ffffff;
  color: #161d26;
}
.home-station-header span:hover,
.home-station-header .active {
  background: linear-gradient(
    91deg,
    rgba(255, 255, 255, 0.3255) 0%,
    #4d96f5 0%,
    #3067e9 56%,
    #509bf6 99%
  );
  border: 1px solid #ffffff;
  color: #fff;
}
.home-station-main .content {
  width: 1300px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}
.home-station-main .content .text {
  position: absolute;
  left: 50px;
  bottom: 160px;
}
.home-station-main .content .text h2 {
  font-family: PingFangSC;
  font-size: 32px;
  font-weight: normal;
  line-height: 32px;
  letter-spacing: 0em;
  color: #161d26;
  margin-bottom: 45px;
}
.home-station-main .content .text p {
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0em;
  color: #414141;
  margin-top: 33px;
}
.home-station-main .content .box {
  position: absolute;
  width: 800px;
  height: 540px;
  right: 0;
  bottom: 60px;
  /* background-color: red; */
}
.home-station-main .content .box .box1 {
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 29px;
  background: rgba(255, 255, 255, 0.28);
  box-sizing: border-box;
  border: 3px solid #ffffff;
  z-index: 10;
}
.home-station-main .content .box .box1 img {
  display: block;
  height: 40px;
  margin: 15px auto 0;
}
.home-station-main .content .box .box1 p {
  margin-top: 15px;
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0em;
  color: rgba(65, 65, 65, 0.34);
}
.home-station-main .content .box .box1 .img1 {
  display: none;
}
.home-station-main .content .box .box1 .img2 {
  display: block;
}

.home-station-main .content .box .box1:hover {
  background: #ffffff;
  box-shadow: 1px 3px 24px 0px rgba(76, 117, 244, 0.6);
}
.home-station-main .content .box .box1:hover p {
  color: #414141;
}
.home-station-main .content .box .box1:hover .img2 {
  display: none;
}
.home-station-main .content .box .box1:hover .img1 {
  display: block;
}

.home-station-main .content .box .img27 {
  position: absolute;
  width: 400px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
}
.home-station-main .content .box .line {
  background: #dddddd;
  border-radius: 4px;
  position: absolute;
}
.line1 {
  width: 195px;
  height: 4px;
  left: 130px;
  top: 50%;
}
.line2 {
  width: 4px;
  height: 135px;
  left: 195px;
  top: 139px;
}
.line3 {
  width: 154px;
  height: 4px;
  left: 43px;
  top: 179px;
}
.line4 {
  height: 40px;
  width: 4px;
  top: 142px;
  left: 43px;
}
.line5 {
  width: 248px;
  height: 4px;
  right: 57px;
  top: 50%;
}
.line6 {
  height: 135px;
  width: 4px;
  right: 230px;
  top: 139px;
}
.line7 {
  height: 135px;
  width: 4px;
  right: 87px;
  top: 139px;
}
.line8 {
  height: 130px;
  width: 4px;
  left: 290px;
  bottom: 140px;
}
.line9 {
  height: 130px;
  width: 4px;
  left: 150px;
  bottom: 140px;
}
.line10 {
  height: 130px;
  width: 4px;
  right: 57px;
  bottom: 140px;
}
.home-machine {
  background: #f4f8fc;
}
.home-machine-main {
  width: 1200px;
  margin: 80px auto 0;
  height: calc(100vh - 330px);
  display: flex;
  align-items: center;
}
.home-machine-main .box {
  width: 410px;
  height: 500px;
  background: #f1f5fb;
  box-shadow: 0px 0px 10px 0px rgba(76, 117, 244, 0.4353);
  padding: 45px 40px;
  position: relative;
  margin-left: -10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.home-machine-main .box h3 {
  padding-left: 35px;
  font-family: PingFangSC;
  font-size: 32px;
  font-weight: normal;
  line-height: 32px;
  letter-spacing: 0em;
  color: #161d26;
}
.home-machine-main .box .text {
  display: flex;
  align-items: center;
  height: 36px;
  /* margin-top: 50px; */
}
.home-machine-main .box .text img {
  display: block;
  width: 36px;
  height: 36px;
}
.home-machine-main .box .text p {
  padding-left: 20px;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 21px;
  letter-spacing: 0em;
  color: #414141;
}
.home-machine-main .box1 {
  height: 540px;
  /* margin-top: -20px; */
  background: linear-gradient(193deg, #d5e6fc 2%, #f2f7fe 24%, #ffffff 36%);
  border: 1px solid #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(76, 117, 244, 0.4353);
}
.home-machine-main .box1 .text {
  height: 42px;
}
.home-machine-main .box1 .text img {
  width: 42px;
  height: 42px;
}
.home-info {
  display: flex;
  justify-content: center;
  align-items: center;
}
.home-info-main {
  /* margin: 150px auto 0; */
  width: 1200px;
  display: flex;
}
.home-info-main .left {
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.home-info-main .left .msg {
  display: flex;
}
.home-info-main .left .msg img {
  display: block;
  width: 81px;
  height: 71px;
}
.home-info-main .left .msg > div {
  padding: 0 20px;
}
.home-info-main .left .msg > div h3 {
  font-family: PingFangSC;
  font-size: 24px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #161d26;
  margin: 20px 0;
}
.home-info-main .left .msg > div p {
  line-height: 22px;
  font-family: PingFangSC;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #414141;
}
.home-info-main .right {
  display: block;
  height: 500px;
}
.home-system {
  background: #f4f8fc;
}
.home-system-main {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.home-system h2 {
  margin-top: 0;
}
.home-system-main h3 {
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0em;
  color: #414141;
  margin-top: 50px;
}
.home-system-count {
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
}
.home-system-count .text {
}
.home-system-count .text h4 {
  font-family: PingFangSC;
  font-size: 70px;
  font-weight: normal;
  line-height: 96px;
  text-align: center;
  letter-spacing: 0em;
  color: #0375f9;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  opacity: 1;
}
.home-system-count .text p {
  margin-top: 20px;
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0em;
  color: #414141;
}
.home-system-bottom {
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.home-system-bottom .img1 {
  position: absolute;
  left: 175px;
  top: 10px;
  width: 290px;
}
.home-system-bottom .img2 {
  position: absolute;
  right: 220px;
  top: 10px;
  width: 340px;
}
.home-system-bottom .box {
}
.home-system-bottom .box h5 {
  padding-left: 13px;
  font-family: PingFangSC;
  font-size: 24px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0em;
  color: #161d26;
  position: relative;
  margin-bottom: 10px;
}
.home-system-bottom .box h5::before {
  display: block;
  content: "";
  width: 8px;
  height: 25px;
  opacity: 1;
  background: #0375f9;
  position: absolute;
  left: 0;
}
.home-system-bottom .box div {
  padding-left: 13px;
  font-family: PingFangSC;
  font-size: 16px;
  font-weight: normal;
  line-height: 29px;
  letter-spacing: 0em;
  color: #414141;
}
.home-used-main {
  /* width: 1200px; */
  width: fit-content;
  height: calc(100vh - 300px);
  margin: 50px auto;
  position: relative;
  display: flex;
}
.home-used-main .bg {
  height: calc(100vh - 300px);
  position: relative;
  /* z-index: 10; */
  /* position: absolute;
  left: 50%;
  transform: translateX(-50%); */
}
.home-used-main .tools {
  position: absolute;
  top: 59%;
  left: 50%;
  transform: translateX(-50%);
  width: 237px;
  height: 72px;
  border-radius: 36px;
  opacity: 1;
  background: #ffffff;
  font-family: PingFangSC;
  font-size: 45px;
  font-weight: normal;
  line-height: 72px;
  text-align: center;
  letter-spacing: 0em;
  color: #0573ed;
  box-shadow: 1px 1px 12px 0px rgba(76, 117, 244, 0.6039);
}
.home-used-main .box {
  display: flex;
  justify-content: space-between;
  width: 237px;
  height: 72px;
  border-radius: 36px;
  opacity: 1;
  /* background: #ffffff; */
  box-shadow: 1px 1px 12px 0px rgba(76, 117, 244, 0.6039);
  border: 3px solid #ffffff;
  position: absolute;
  /* padding: 0 18px; */
}
.home-used-main .box:nth-of-type(2n) {
  padding-left: 18px;
}
.home-used-main .box:nth-of-type(2n + 1) {
  padding-right: 18px;
}
.home-used-main .box p {
  flex: auto;
  line-height: 72px;
  font-family: PingFangSC;
  font-size: 22px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  color: #414141;
  text-align: center;
}
.home-used-main .box .img {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  margin-top: -2px;
  margin-right: -1px;
  margin-left: -1px;
}
.home-used-main .box .img img {
  display: block;
  height: 46px;
  width: 46px;
  margin: 13px auto;
}
.home-used-main .box:hover {
  border: 3px solid #0079ff;
}
.home-used-main .box:hover .img {
  background: #0079ff;
}
.home-used-main .box1 {
  top: 8%;
  right: 65%;
}
.home-used-main .box1 .img .img1 {
  display: block;
}
.home-used-main .box1 .img .img2 {
  display: none;
}
.home-used-main .box1:hover .img .img1 {
  display: none;
}
.home-used-main .box1:hover .img .img2 {
  display: block;
}
.home-used-main .box2 {
  top: 8%;
  left: 65%;
}
.home-used-main .box2 .img .img1 {
  display: block;
}
.home-used-main .box2 .img .img2 {
  display: none;
}
.home-used-main .box2:hover .img .img1 {
  display: none;
}
.home-used-main .box2:hover .img .img2 {
  display: block;
}
.home-used-main .box3 {
  top: 31%;
  right: 90%;
}
.home-used-main .box3 .img .img1 {
  display: block;
}
.home-used-main .box3 .img .img2 {
  display: none;
}
.home-used-main .box3:hover .img .img1 {
  display: none;
}
.home-used-main .box3:hover .img .img2 {
  display: block;
}
.home-used-main .box4 {
  top: 31%;
  left: 90%;
}
.home-used-main .box4 .img .img1 {
  display: block;
}
.home-used-main .box4 .img .img2 {
  display: none;
}
.home-used-main .box4:hover .img .img1 {
  display: none;
}
.home-used-main .box4:hover .img .img2 {
  display: block;
}
.home-used-main .box5 {
  bottom: 31%;
  right: 90%;
}
.home-used-main .box5 .img .img1 {
  display: block;
}
.home-used-main .box5 .img .img2 {
  display: none;
}
.home-used-main .box5:hover .img .img1 {
  display: none;
}
.home-used-main .box5:hover .img .img2 {
  display: block;
}
.home-used-main .box6 {
  bottom: 31%;
  left: 90%;
}
.home-used-main .box6 .img .img1 {
  display: block;
}
.home-used-main .box6 .img .img2 {
  display: none;
}
.home-used-main .box6:hover .img .img1 {
  display: none;
}
.home-used-main .box6:hover .img .img2 {
  display: block;
}
.home-used-main .box7 {
  bottom: 4%;
  right: 65%;
}
.home-used-main .box7 .img .img1 {
  display: block;
}
.home-used-main .box7 .img .img2 {
  display: none;
}
.home-used-main .box7:hover .img .img1 {
  display: none;
}
.home-used-main .box7:hover .img .img2 {
  display: block;
}
.home-used-main .box8 {
  bottom: 4%;
  left: 65%;
}
.home-used-main .box8 .img .img1 {
  display: block;
}
.home-used-main .box8 .img .img2 {
  display: none;
}
.home-used-main .box8:hover .img .img1 {
  display: none;
}
.home-used-main .box8:hover .img .img2 {
  display: block;
}
.home-about {
  background: #f4f8fc;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  padding-bottom: 10px;
}
.home-about-items {
  width: 1200px;
  margin: 50px auto;
  display: flex;
  justify-content: space-evenly;
  position: relative;
}
.home-about-items .box {
  width: 118px;
  height: 118px;
}
.home-about-items .box img {
  display: block;
  width: 100px;
  height: 100px;
}
.home-about-items .box p {
  margin-top: 22px;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0em;
  color: #414141;
}
.home-about-items .line {
  display: block;
  position: absolute;
  width: 185px;
  top: 40px;
  height: 16px;
}
.home-about-items .line1 {
  left: 235px;
}
.home-about-items .line2 {
  left: 500px;
}
.home-about-items .line3 {
  left: 765px;
}
.home-about-main {
  width: 1200px;
  margin: 50px auto;
  display: flex;
  justify-content: space-between;
}
.home-about-main .left {
  position: relative;
  width: 580px;
  padding: 42px 52px 251px;
  margin-right: 40px;
  background: #0079ff;
  color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(76, 117, 244, 0.4392);
}
.home-about-main .left h2 {
  font-family: PingFangSC;
  font-size: 45px;
  font-weight: normal;
  line-height: 45px;
  letter-spacing: 0em;
}
.home-about-main .left p {
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: normal;
  line-height: 36px;
  letter-spacing: 0em;
}
.home-about-main .left .code {
  position: absolute;
  bottom: 27px;
  left: 52px;
}
.home-about-main .left .code span {
  font-family: PingFangSC;
  font-size: 20px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0em;
}
.home-about-main .left .code img {
  display: block;
  width: 150px;
  height: 150px;
  margin-top: 28px;
}
.home-about-main .right {
  flex: auto;
}
.ant-form-item .ant-form-item-label > label {
  font-size: 18px;
}
.home-about-main .right .submit .tip {
  font-family: PingFangSC;
  font-size: 16px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0em;
  color: #c4c4c6;
  margin-bottom: 19px;
}
.home-about-main .right .submit .tip a {
  color: #226fff;
}
.home-about-main .right .submit .btn {
  width: 186px;
  height: 46px;
  opacity: 1;
  font-family: PingFangSC;
  font-size: 16px;
  font-weight: normal;
  line-height: 46px;
  text-align: center;
  letter-spacing: 0em;
  cursor: pointer;
  color: #ffffff;
  background: linear-gradient(103deg, #70a0fa 6%, #226fff 93%);
  box-shadow: 2px 2px 3px 0px #e3e3e3;
}
</style>
